import axios from "axios";

export const employeesAPI = {
  getEmployees() {
    return axios.get("/api/v1/employee/").then((res) => res.data);
  },
};
